import { useMutation, useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';

import type {
  AuthApi,
  AuthOtpResponse,
  AuthSuccessResponse,
  InitiateParams,
  RespondParams,
  ValidateResponse,
} from '../api';
import type { UserInfo } from '../auth';

export const useInitiateMutation = (
  api: AuthApi,
  options?: UseMutationOptions<AuthOtpResponse, Error, InitiateParams, unknown>
) => useMutation((params: InitiateParams) => api.initiate(params), options);

export const useConfirmMutation = (
  api: AuthApi,
  options?: UseMutationOptions<
    AuthSuccessResponse,
    Error,
    RespondParams,
    unknown
  >
) => useMutation((params: RespondParams) => api.respond(params), options);

export const useValidateQuery = (
  api: AuthApi,
  options?: UseQueryOptions<ValidateResponse>
) =>
  useQuery({
    queryKey: ['validate'],
    queryFn: () => api.validate(),
    cacheTime: 0,
    ...options,
  });

export const useUserInfoQuery = (
  api: AuthApi,
  options?: UseQueryOptions<UserInfo>
) =>
  useQuery({
    queryKey: ['userInfo'],
    queryFn: () => api.getUserInfo(),
    cacheTime: 0,
    ...options,
  });

export const useRevokeQuery = (
  api: AuthApi,
  options?: UseQueryOptions<AuthSuccessResponse>
) =>
  useQuery({
    queryKey: ['revoke'],
    queryFn: () => api.revoke(),
    ...options,
  });
